export const SAN_ANTONIO_COORDS = {
  lat: 29.450800890549672,
  lng: -98.49240379327378,
};
